<template>
  <v-expansion-panels
    v-if="! noWrappingPanels"
    class="mt-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header class="justify-self-start">
        <div class="d-flex align-center">
          <v-icon class="pr-8">
            $vuetify.icons.openai
          </v-icon>
          <span>{{ title }}</span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

  <v-expansion-panel v-else>
    <v-expansion-panel-header class="justify-self-start">
      <div class="d-flex align-center">
        <v-icon class="pr-8">
          $vuetify.icons.openai
        </v-icon>
        <span>{{ title }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: 'OpenAI (ChatGPT)'
    },
    noWrappingPanels: {
      type: Boolean,
    }
  }
}
</script>